import React, {useState, useRef, useEffect} from "react";
import {connect} from "react-redux";
import CaseDuplicate, {CaseDuplicateProps} from "./CaseDuplicate.tsx";
import {getCaseFormCaseHeader} from "requests/homeowner/caseforms";
import {MDialog, MSpinner} from "components/Shared";
import {getCustomerList} from "requests/customer";
import {userHasRight} from "selectors/rights";
import {
  CASE_DUPLICATE,
  CASE_DUPLICATE_FOR_CUSTOMER,
  CASE_DUPLICATE_WITH_ACCOUNT_SURVEY_TYPE
} from "typeConstants/rights";
import {CustomerDto, Header} from "interfaces/Mueller.Business.Models.ts";

interface CaseDuplicateAsDialogProps extends CaseDuplicateProps {
  visible: boolean,
  hideDialog: () => void
}

const CaseDuplicateAsDialog = (props: CaseDuplicateAsDialogProps) => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [caseHeader, setCaseHeader] = useState<Header>(null);
  const [fetchingAccountList, setFetchingAccountList] = useState<boolean>(true);
  const [accountList, setAccountList] = useState<CustomerDto[]>(null);

  const mounted = useRef(true);

  const {canDuplicate, controlNumber, canDuplicateWithAccountSurveyType, canDuplicateAsCustomer} = props;
  const isExternalUser = canDuplicateAsCustomer && !(canDuplicate || canDuplicateWithAccountSurveyType);

  useEffect(() => {
    getCaseFormCaseHeader(controlNumber, setCaseHeader, mounted);
    getCustomerList(setAccountList, mounted);

    return () => {
      mounted.current = false;
    };
  }, []);

  useEffect(() => {
    setIsLoading(!caseHeader);
  }, [caseHeader]);

  useEffect(() => {
    setFetchingAccountList(!accountList);
  }, [accountList]);

  const caseDuplicateProps = (isLoading || fetchingAccountList) ? null : {
    ...props,
    controlNumber: controlNumber,
    currentAccount: caseHeader.policyInfo.customerInfo,
    surveyAddress: caseHeader.policyInfo.surveyAddress,
    currentInspectionType: caseHeader.caseInfo.currentInspectionType,
    originalInspectionType: caseHeader.caseInfo.originalInspectionType,
    specialAttentionNotes: caseHeader.caseInfo.webNotes,
    fetchingAccountList: fetchingAccountList,
    accountList: accountList,
    portalTargetClass: "copy-case-dialog",
    onFinished: props.hideDialog
  } as CaseDuplicateProps;
  const dialogContent = (isLoading || fetchingAccountList) ?
          <MSpinner /> :
          <CaseDuplicate {...caseDuplicateProps} />;
  return (
          <MDialog
                  id="copy-dialog"
                  className="copy-case-dialog"
                  visible={props.visible}
                  onHide={props.hideDialog}
                  title={`${isExternalUser ? "Re-Order" : "Duplicate"} Case`}
                  width={400}
          >
            {dialogContent}
          </MDialog>
  );
}

const mapStateToProps = (state) => {
  return {
    canDuplicateAsCustomer: userHasRight(CASE_DUPLICATE_FOR_CUSTOMER)(state),
    canDuplicateWithAccountSurveyType: userHasRight(CASE_DUPLICATE_WITH_ACCOUNT_SURVEY_TYPE)(state),
    canDuplicate: userHasRight(CASE_DUPLICATE)(state),
  };
};

export default connect(mapStateToProps)(CaseDuplicateAsDialog);
